export default [  
  {
    path: '/reps',
    name: 'reps',
    component: () => import('@/views/modules/reps/list'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      title:'Reps List',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Reps' }
      ]
    },
    children:[
      {
        path: '/reps/create',
        name: 'reps-create',
        component: () => import('@/views/modules/reps/create'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Rep Create',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Reps', link: '/reps' },
            { text: 'Create' }
          ]
        }
      },
      {
        path: '/reps/:id/edit',
        props: true,
        name: 'reps-edit',
        component: () => import('@/views/modules/reps/edit'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Reps Edit',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Rep',  to: { name: "reps-show" }, param: 'id' },
            { text: 'Edit' }
          ]
        }
      },
     
    
    ]
  },
 
]